import { useEffect } from 'react';
export const useFetchNextPage = ({ rowVirtualizer, hasNextPage, isFetching, rows, fetchNextPage, triggerBottomRowIndex, }) => {
    useEffect(() => {
        const lastItem = rowVirtualizer.getVirtualItems().slice(-1)[0];
        if (!!lastItem && lastItem.index >= rows.length - 1 - triggerBottomRowIndex && hasNextPage && !isFetching)
            fetchNextPage();
    }, [hasNextPage, fetchNextPage, rows.length, isFetching, rowVirtualizer.getVirtualItems()]);
};
